// extracted by mini-css-extract-plugin
export var attachButton = "_gk-8";
export var sendButton = "_gk-2";
export var sendDisabled = "_gk-4";
export var sendEnabled = "_gk-3";
export var sendIcon = "_gk-6";
export var sendIconDisabled = "_gk-7";
export var sendStreaming = "_gk-5";
export var textarea = "_gk-1";
export var wrapper = "_gk-0";